/* eslint-disable new-cap */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useOutletContext } from 'react-router-dom';
import * as Yup from 'yup';
import { IReport } from '../../../interfaces/Models';
import { reportTypes } from '../../../common/Constants';
import ErrorMessage from '../../../components/ErrorMessage';
import { HMPFirstValues } from '../../../common/reportsFieldsValues/hmp/HMPFirstValues';
import HMPFirstFields from './fields/HMPFirstFields';
import GenericField from '../sharedFields/GenericField';
import { HMPReleaseFields } from '../../../common/ReleaseFields';
import SectionDivider from '../../../components/SectionDivider';
import StatusFields from './fields/StatusFields';
import ReportsForm from '../../../components/Form/ReportsForm';

const HMPRelease = () => {
  const { t } = useTranslation();
  const { visitId } = useParams();
  const data: IReport | null = useOutletContext();

  const initialValues =
    data && data.name
      ? data
      : {
          name: reportTypes.HMP_RELEASE,
          visit: visitId,
          data: data ? data : HMPFirstValues,
        };
  const ReportSchema = Yup.object({
    name: Yup.string().required(t('clinic.form.required')),
    visit: Yup.string().required(t('clinic.form.required')),
    data: Yup.object().shape({}),
  });

  const HtmlId = 'HMPRelease';

  if (data?.name && data.name != reportTypes.HMP_RELEASE) {
    return <ErrorMessage error={t('global.errors.somethingWrong')} />;
  }
  return (
    <ReportsForm
      initialValues={initialValues}
      visitId={visitId || ''}
      validationSchema={ReportSchema}
    >
      <HMPFirstFields id={HtmlId} />
      <GenericField
        id={`${HtmlId}_Receipt`}
        subHeader={t('report.HMPGENERAL.receipt.release')}
        fields={HMPReleaseFields}
      />
      <StatusFields id={HtmlId} />
      <SectionDivider />
    </ReportsForm>
  );
};

export default HMPRelease;
